module.exports = __webpack_public_path__ + "media/images/flags/16/Chile-4c0ee239733e14f939babb51b7234dea.png";